import React from "react";
import { ShieldAlert } from "lucide-react";
import { useContent } from "../context/ContentContext";

export function DepositNotice({ className = "" }) {
  const { content } = useContent();
  const po = content?.payment_options || {};
  if (po.deposit_enabled === false) return null;
  const pct = po.deposit_percent ?? 30;
  return (
    <div
      data-testid="deposit-notice"
      className={`rounded-xl bg-gold/10 border border-gold/40 text-forest px-4 py-3 text-sm flex items-start gap-2 ${className}`}
    >
      <ShieldAlert size={16} className="text-gold mt-0.5 shrink-0" />
      <span>
        A <strong>{pct}% non-refundable deposit</strong> is required to confirm your reservation. By
        proceeding, you agree that this payment is non-refundable.
      </span>
    </div>
  );
}
